import React from "react";
import { Col, Row } from "antd";
import classNames from "classnames";
import { wrap } from "../../helpers/array";

export interface HeaderProps {
  children?: React.ReactNode | React.ReactNode[];
  justifyContent?: "space-between" | "start";
}

const Header: React.FC<HeaderProps> = ({
  children,
  justifyContent = "space-between",
}) => {
  if (!children) {
    return null;
  }

  return (
    <div className={classNames("card__header", justifyContent)}>
      <Row gutter={15}>
        {wrap(children).map((component, index) => (
          <Col key={index.toString()}>{component}</Col>
        ))}
      </Row>
    </div>
  );
};

export default Header;
